export const stackedList = 'flex flex-col gap-1 pb-2 mt-4';
